import { render } from "./RocaGroup2021View.vue?vue&type=template&id=87e5f78c"
import script from "./RocaGroup2021View.vue?vue&type=script&lang=js"
export * from "./RocaGroup2021View.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__